import { useNavigate } from "react-router-dom";
import { useSupabaseQuery } from "@/hooks/useSupabaseQuery";
import { fetchAggregateWinRate } from "@/features/dashboard/api";
import { StatCard } from "@/components/ui/StatCard";
import { Skeleton } from "@/components/ui/Skeleton";
import { formatPercentage } from "@/lib/format";

export function WinRateCard() {
  const navigate = useNavigate();
  const winRateQuery = useSupabaseQuery(() => fetchAggregateWinRate(), []);

  if (winRateQuery.isLoading) {
    return (
      <div className="stat-card stat-card-clickable" role="link" tabIndex={0} onClick={() => navigate("/strategies")}>
        <Skeleton width="80px" height="0.6875rem" />
        <Skeleton width="60px" height="1.5rem" />
      </div>
    );
  }

  const value = winRateQuery.data;

  return (
    <StatCard
      label="Win rate"
      value={value !== null ? formatPercentage(value, 1) : "—"}
      onClick={() => navigate("/strategies")}
    />
  );
}
